export default {
    title: "Raccomandazioni del consigliere",
    noItems: "Nessuna raccomandazione"
}